"use client";
import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";

export default function ProtectedPage({ children }) {
    const router = useRouter();
    const [isAllowed, setIsAllowed] = useState(false); // auth verify hone tak false

    useEffect(() => {
        const token = localStorage.getItem("authToken");
        const userId = localStorage.getItem("userId");

        if (!token || !userId) {
            router.replace("/login");
        } else {
            setIsAllowed(true); // ab child render karne do
        }
    }, [router]);

    // Jab tak auth verify nahi hua, kuch render mat karo
    if (!isAllowed) return null;

    return <>{children}</>;
}
